import { Box, FileInput, Group, Stack, Badge, Text } from '@mantine/core';

import { ConfirmationSection } from '../components/ConfirmationSection';
import { DryRunSection } from '../components/DryRunSection';
import { useCsvUpload } from '../hooks/useCSVUpload';
import { FileUploadStatus } from '../types';

type CSVUploaderProps = {
  file: File | null;
  rowsCount: number;
  status: FileUploadStatus;
  handleFileUpload: (file: File | null) => void;
};

const CSVUploader = ({ file, handleFileUpload, rowsCount, status }: CSVUploaderProps) => {
  return (
    <Stack>
      <Group align="flex-end" justify="center">
        <FileInput
          label="Upload CSV from Meta"
          placeholder="Select CSV file"
          accept=".csv"
          value={file}
          onChange={handleFileUpload}
        />
        {status && (
          <Badge
            color={status === 'loaded' ? 'green' : status === 'error' ? 'red' : ''}
            sx={{ marginBottom: '8px' }}
          >
            {status.toUpperCase()}
          </Badge>
        )}
      </Group>
      {file && status === 'loaded' && (
        <Box>
          <Text>Uploaded File: {file.name}</Text>
          <Text>Rows count: {rowsCount}</Text>
        </Box>
      )}
    </Stack>
  );
};

export const UserDataDeletionPage = () => {
  const { file, rowsCount, status, ids, handleFileUpload } = useCsvUpload();

  return (
    <Box w={600} mx="auto">
      <Stack>
        <CSVUploader
          file={file}
          rowsCount={rowsCount}
          status={status}
          handleFileUpload={handleFileUpload}
        />
        <DryRunSection chatIds={ids} file={file} />
        <ConfirmationSection chatIds={ids} file={file} />
      </Stack>
    </Box>
  );
};
